import styled from 'styled-components';
import { cssVars } from '../../../shared/lib/styledTheme';

export const TicketChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  background-color: ${cssVars.bgColor};
`;

export const TicketChatHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid ${cssVars.borderColor};
  background-color: ${cssVars.bgSecondary};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const TicketChatTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  gap: 12px;
`;

export const TicketChatTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
`;

export const TicketTypeBadge = styled.span`
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background-color: #7B6CF0;
  color: ${cssVars.white};
`;

export const TicketSiteBadge = styled.span<{ $site: string }>`
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background-color: ${props => props.$site === 'hudle' ? '#4CAF50' : '#2196F3'};
  color: ${cssVars.white};
`;

export const TicketChatSubtitle = styled.div`
  font-size: 13px;
  color: ${cssVars.textSecondary};
`;

export const StatusAndInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StatusSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  flex-wrap: wrap;
`;

export const StatusButton = styled.button<{ $hasValue?: boolean }>`
  min-width: 140px;
  padding: 8px 12px;
  border: 1px solid ${props => props.$hasValue ? cssVars.primary : cssVars.borderColor};
  border-radius: 8px;
  background-color: ${props => props.$hasValue ? cssVars.primary + '15' : cssVars.bgColor};
  color: ${cssVars.textPrimary};
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:focus {
    border-color: ${cssVars.primary};
    box-shadow: 0 0 0 2px ${cssVars.primary}10;
  }

  &:hover {
    border-color: ${cssVars.primary};
    background-color: ${props => props.$hasValue ? cssVars.primary + '20' : cssVars.hover};
  }
`;

export const SiteButton = styled.button<{ $hasValue?: boolean }>`
  min-width: 140px;
  padding: 8px 12px;
  border: 1px solid ${props => props.$hasValue ? cssVars.primary : cssVars.borderColor};
  border-radius: 8px;
  background-color: ${props => props.$hasValue ? cssVars.primary + '15' : cssVars.bgColor};
  color: ${cssVars.textPrimary};
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:focus {
    border-color: ${cssVars.primary};
    box-shadow: 0 0 0 2px ${cssVars.primary}10;
  }

  &:hover {
    border-color: ${cssVars.primary};
    background-color: ${props => props.$hasValue ? cssVars.primary + '20' : cssVars.hover};
  }
`;

export const CategoryButton = styled.button<{ $hasCategory?: boolean }>`
  min-width: 140px;
  padding: 8px 12px;
  border: 1px solid ${props => props.$hasCategory ? cssVars.primary : cssVars.borderColor};
  border-radius: 8px;
  background-color: ${props => props.$hasCategory ? cssVars.primary + '15' : cssVars.bgColor};
  color: ${cssVars.textPrimary};
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:focus {
    border-color: ${cssVars.primary};
    box-shadow: 0 0 0 2px ${cssVars.primary}10;
  }

  &:hover {
    border-color: ${cssVars.primary};
    background-color: ${props => props.$hasCategory ? cssVars.primary + '20' : cssVars.hover};
  }
`;

export const TemplatesButton = styled.button`
  min-width: 100px;
  padding: 8px 12px;
  border: 1px solid ${cssVars.borderColor};
  border-radius: 8px;
  background-color: ${cssVars.bgColor};
  color: ${cssVars.textPrimary};
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
  text-align: center;
  white-space: nowrap;

  &:focus {
    border-color: ${cssVars.primary};
    box-shadow: 0 0 0 2px ${cssVars.primary}10;
  }

  &:hover {
    border-color: ${cssVars.primary};
    background-color: ${cssVars.hover};
  }
`;

export const CreateYTicketButton = styled.button`
  min-width: 140px;
  padding: 8px 12px;
  border: 1px solid ${cssVars.borderColor};
  border-radius: 8px;
  background-color: ${cssVars.bgColor};
  color: ${cssVars.textPrimary};
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
  text-align: center;
  white-space: nowrap;

  &:focus {
    border-color: ${cssVars.primary};
    box-shadow: 0 0 0 2px ${cssVars.primary}10;
  }

  &:hover:not(:disabled) {
    border-color: ${cssVars.primary};
    background-color: ${cssVars.hover};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const MessagesContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: ${cssVars.bgColor};
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${cssVars.textSecondary};
`;

export const MessagesEndRef = styled.div`
  height: 0;
  width: 0;
`;

export const MessageWrapper = styled.div<{ $direction: 'incoming' | 'outgoing' }>`
  display: flex;
  flex-direction: column;
  align-items: ${props => props.$direction === 'incoming' ? 'flex-start' : 'flex-end'};
  width: 100%;
  padding-left: ${props => props.$direction === 'incoming' ? '0' : '20%'};
  padding-right: ${props => props.$direction === 'outgoing' ? '0' : '20%'};
`;

export const MessageBubble = styled.div<{ $direction: 'incoming' | 'outgoing'; $isInternal?: boolean; $themeMode?: 'light' | 'dark' }>`
  max-width: 80%;
  padding: 14px 16px;
  border-radius: 12px;
  background-color: ${props => {
    if (props.$isInternal) {
      if (props.$themeMode === 'dark') {
        return props.$direction === 'incoming' 
          ? 'rgba(139, 69, 19, 0.15)' 
          : 'rgba(25, 118, 210, 0.15)';
      } else {
        return props.$direction === 'incoming' 
          ? '#FFE0B2' 
          : '#BBDEFB';
      }
    }
    return props.$direction === 'incoming' 
      ? cssVars.bgSecondary 
      : cssVars.primary;
  }};
  color: ${props => {
    if (props.$isInternal) {
      if (props.$themeMode === 'dark') {
        return props.$direction === 'incoming' 
          ? '#FFB74D' 
          : '#64B5F6';
      } else {
        return props.$direction === 'incoming' 
          ? '#BF360C' 
          : '#0D47A1';
      }
    }
    return props.$direction === 'incoming' 
      ? cssVars.textPrimary 
      : cssVars.white;
  }};
  border: ${props => {
    if (!props.$isInternal) return 'none';
    if (props.$themeMode === 'dark') {
      return `1px solid ${props.$direction === 'incoming' ? 'rgba(255, 183, 77, 0.3)' : 'rgba(100, 181, 246, 0.3)'}`;
    } else {
      return `1px solid ${props.$direction === 'incoming' ? '#FFB74D' : '#64B5F6'}`;
    }
  }};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`;

export const InternalBadge = styled.div<{ $direction: 'incoming' | 'outgoing'; $themeMode?: 'light' | 'dark' }>`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${props => {
    if (props.$themeMode === 'dark') {
      return props.$direction === 'incoming' ? '#FFB74D' : '#64B5F6';
    } else {
      return props.$direction === 'incoming' ? '#E65100' : '#1565C0';
    }
  }};
  margin-bottom: 8px;
  opacity: 1;
  letter-spacing: 0.5px;
`;

export const ClientEmailLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${cssVars.textSecondary};
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const ClientEmail = styled.span`
  font-weight: 500;
  margin-left: 6px;
  color: ${cssVars.textPrimary};
  text-transform: none;
`;

export const MessageLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${cssVars.textSecondary};
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const AuthorName = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${cssVars.white};
  margin-bottom: 6px;
  opacity: 0.95;
`;

export const MessageContent = styled.div<{ $isInternal?: boolean; $themeMode?: 'light' | 'dark' }>`
  font-size: 14px;
  line-height: 1.6;
  word-wrap: break-word;
  white-space: pre-wrap;
  margin-top: 4px;
  font-weight: ${props => props.$isInternal && props.$themeMode === 'light' ? '500' : 'normal'};
`;

export const MessageTimestamp = styled.div<{ $isOutgoing?: boolean }>`
  font-size: 11px;
  color: ${props => props.$isOutgoing ? cssVars.white : cssVars.textTertiary};
  margin-top: 8px;
  opacity: 0.7;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const AuthorNameInTimestamp = styled.span`
  font-weight: 500;
  opacity: 0.9;
  margin-left: 4px;
`;

export const MessageInputContainer = styled.div`
  padding: 20px 24px;
  border-top: 1px solid ${cssVars.borderColor};
  background-color: ${cssVars.bgSecondary};
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);
`;

export const AttachmentButton = styled.button`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${cssVars.borderColor};
  background-color: ${cssVars.bgColor};
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;
  transition: all 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
    border-color: ${cssVars.primary};
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const MessageInputWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
  align-items: flex-end;
`;

export const MessageTextarea = styled.textarea`
  flex: 1;
  min-height: 80px;
  max-height: 200px;
  padding: 14px 16px;
  border: 1px solid ${cssVars.borderColor};
  border-radius: 10px;
  background-color: ${cssVars.bgColor};
  color: ${cssVars.textPrimary};
  font-size: 14px;
  font-family: inherit;
  resize: none;
  outline: none;
  line-height: 1.5;
  transition: all 0.2s;

  &:focus {
    border-color: ${cssVars.primary};
    box-shadow: 0 0 0 3px ${cssVars.primary}10;
  }

  &::placeholder {
    color: ${cssVars.textTertiary};
  }
`;

export const SendButton = styled.button`
  padding: 14px 28px;
  background-color: ${cssVars.primary};
  color: ${cssVars.white};
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: ${cssVars.primaryHover};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const InputOptions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid ${cssVars.borderColor};
`;

export const InternalCheckbox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: ${cssVars.textSecondary};

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: ${cssVars.primary};
  }

  label {
    cursor: pointer;
    user-select: none;
  }
`;

export const AttachmentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
  padding: 8px;
  background-color: ${cssVars.bgSecondary};
  border-radius: 6px;
  border: 1px solid ${cssVars.borderColor};
`;

export const AttachmentItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  background-color: ${cssVars.bgColor};
  border-radius: 4px;
  border: 1px solid ${cssVars.borderColor};
`;

export const AttachmentName = styled.span`
  font-size: 12px;
  color: ${cssVars.textPrimary};
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RemoveAttachmentButton = styled.button`
  background: none;
  border: none;
  color: ${cssVars.textSecondary};
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
    color: ${cssVars.error};
  }
`;

export const MessageAttachmentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`;

export const MessageAttachmentItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AttachmentLink = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: ${cssVars.bgSecondary};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  text-decoration: none;
  color: ${cssVars.textPrimary};
  transition: all 0.2s;
  flex: 1;
  min-width: 0;

  &:hover {
    background-color: ${cssVars.hover};
    border-color: ${cssVars.primary};
  }
`;

export const AttachmentIcon = styled.span`
  font-size: 16px;
  flex-shrink: 0;
`;

export const MessageAttachmentName = styled.span`
  font-size: 13px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
`;

export const AttachmentSize = styled.span`
  font-size: 11px;
  color: ${cssVars.textSecondary};
  flex-shrink: 0;
`;

export const AttachmentImage = styled.img`
  max-width: 100%;
  max-height: 300px;
  border-radius: 6px;
  border: 1px solid ${cssVars.borderColor};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.9;
    border-color: ${cssVars.primary};
  }
`;

export const CopyLinkButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background-color: transparent;
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
  color: ${cssVars.textSecondary};

  &:hover {
    background-color: ${cssVars.hover};
    border-color: ${cssVars.primary};
    color: ${cssVars.primary};
  }

  &:active {
    transform: scale(0.95);
  }
`;

